import React, { Component } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';

export class MapContainer extends Component {
    state = {};

    render() {
        return (
            <Map google={this.props.google}
                initialCenter={{
                    lat: 37.569313,
                    lng: 126.979428
                }}>
                <Marker/>
            </Map>
        )
    }
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyBTUuzUF4tuvPyotXJuzuugi4ZaGQo4Dng'
})(MapContainer)
